// Dni pracovného pokoja na Slovensku — JEDNO miesto pre celý Matrix (harmonogram, Rozpis prác).
// Zákon č. 241/1993 Z. z. o štátnych sviatkoch, dňoch pracovného pokoja a pamätných dňoch v znení zákona č. 261/2025 Z. z.
// Mirko 16. 9. 2026 (bod 8): pracovné dni sa rátajú bez sviatkov podľa platného zákona.
//  - 1. 9. (Deň Ústavy SR) nie je dňom pracovného pokoja od roku 2024,
//  - 17. 11. (Deň boja za slobodu a demokraciu) nie je dňom pracovného pokoja od 1. 11. 2025 natrvalo,
//  - 8. 5. a 15. 9. nie sú dňami pracovného pokoja v roku 2026 (prechodné ustanovenie zákona č. 261/2025 Z. z.).
// Keď zákon zmení ďalší rok, upraví sa len funkcia nieJeVolno nižšie.
const PEVNE = {
  '01-01': 'Nový rok / Vznik SR', '01-06': 'Zjavenie Pána', '05-01': 'Sviatok práce', '05-08': 'Deň víťazstva',
  '07-05': 'Cyril a Metod', '08-29': 'SNP', '09-01': 'Deň Ústavy', '09-15': 'Sedembolestná',
  '11-01': 'Všetkých svätých', '11-17': 'Boj za slobodu', '12-24': 'Štedrý deň', '12-25': '1. sviatok vianočný', '12-26': '2. sviatok vianočný',
}

// deň je v zákone ako sviatok, ale v danom roku NIE JE dňom pracovného pokoja
function nieJeVolno(md, rok) {
  if (md === '09-01' && rok >= 2024) return true
  if (md === '11-17' && rok >= 2025) return true
  if ((md === '05-08' || md === '09-15') && rok === 2026) return true
  return false
}

const DEN = 86400000
const utc = (iso) => { const p = String(iso).slice(0, 10).split('-'); return Date.UTC(+p[0], +p[1] - 1, +p[2]) }
const iso = (ms) => new Date(ms).toISOString().slice(0, 10)

// Veľkonočná nedeľa (gregoriánsky kalendár, anonymný algoritmus Meeus/Jones/Butcher)
export function velkonocnaNedela(rok) {
  const a = rok % 19, b = Math.floor(rok / 100), c = rok % 100, d = Math.floor(b / 4), e = b % 4
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451)
  const mesiac = Math.floor((h + l - 7 * m + 114) / 31), den = ((h + l - 7 * m + 114) % 31) + 1
  return rok + '-' + String(mesiac).padStart(2, '0') + '-' + String(den).padStart(2, '0')
}

// Názov dňa pracovného pokoja pre dátum 'RRRR-MM-DD', inak null (víkend sa tu nerieši).
export function sviatok(datum) {
  const s = String(datum || '').slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return null
  const rok = +s.slice(0, 4), md = s.slice(5)
  if (PEVNE[md] && !nieJeVolno(md, rok)) return PEVNE[md]
  const nedela = utc(velkonocnaNedela(rok))
  if (s === iso(nedela - 2 * DEN)) return 'Veľký piatok'
  if (s === iso(nedela + DEN)) return 'Veľkonočný pondelok'
  return null
}

// Víkend alebo deň pracovného pokoja
export function jeVolno(datum) {
  const s = String(datum || '').slice(0, 10)
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return false
  const w = new Date(utc(s)).getUTCDay()
  return w === 0 || w === 6 || !!sviatok(s)
}
